import React from 'react';
import { Route, Switch } from 'react-router';
import ProductManagement from 'modules/ProductManagement';
import { getFeatureToggle, ToggleNames } from 'helpers/featureToggle';

export enum ERoutePath {
    ProductManagement = '/productManagement',
    EditPaymentDetails = '/paymentProfile',
    RequestCancellation = '/cancellation',
}

const Routes: React.FC = () => {
    return (
        <Switch>
            {getFeatureToggle(ToggleNames.FEATURE_PRODUCT_MANAGEMENT) && (
                <Route path={ERoutePath.ProductManagement} children={<ProductManagement />} />
            )}
        </Switch>
    );
};

export default Routes;
